























import ImageObject from "../../../document/editor/objects/ImageObject.vue";
import ObjectMenuButton from "./ObjectMenuButton.vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { PropertyEditableMixin, DrawerPropertyEditableMixin } from "../../../document/editor/propertyEditors/mixins";
import { DrawableItemEditorMixin, CommonComponentsAccessibleMixin } from "../mixins";

@Component({
  components: {
    ObjectMenuButton, 
  }
})

export default class ImageObjectMenu extends Mixins(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  DrawerPropertyEditableMixin,
  CommonComponentsAccessibleMixin,
) {
  @Prop()
  source: ImageObject;

  @Prop()
  isImageRegistrationEnable: boolean;

  get hasImage(): boolean {
    return this.source.hasImage;
  }

  get isEditableImage(): boolean {
    return this.$store.getters.configuration.behavior.document.editor.contents.claio.edit.isEnable
      && this.source.isEditableClaioImage;
  }

  get isClaioSchemaEditableImage(): boolean {
    return this.source.isClaioSchemaEditableImage;
  }

  get isTrimmingEnable(): boolean {
    return this.$configuration.behavior.document.editor.imageEditor.trimming.isEnable;
  }

  get isTrimmableImage(): boolean {
    return this.source.isTrimmableImage;
  }

  async clearSource(): Promise<void> {
    this.source.clearImage();
  }

  get isPastableSourceFromClipboard(): boolean {
    return this.source.isPastableFromClipboard
      && this.isImageRegistrationEnable;
  }

  async pasteSourceFromClipboard(): Promise<void> {
    this.source.pasteImageFromClipboard();
  }

  trimImage(): void {
    this.source.trimImage();
  }

  editImage(): void {
    this.source.editImage();
  }

  editImages(): void {
    this.source.editImages();
  }

  editImagebyClaioSchema(): void {
    this.source.editClaioSchemaWhenNeeded(false);
  }
}
